import type { CSSProperties, ReactNode } from "react";

type Props = {
    id?: string;
    eyebrow?: string;
    heading?: ReactNode;
    intro?: ReactNode;
    align?: "left" | "center";
    surface?: boolean;
    children: ReactNode;
    style?: CSSProperties;
};

// Generic content section. Wraps an optional eyebrow/heading/intro block
// above arbitrary children. The id + `gt-landing-section` class give it
// the scroll-margin treatment used by the in-page anchor sub-nav.
export default function Section({
    id,
    eyebrow,
    heading,
    intro,
    align = "left",
    surface = false,
    children,
    style,
}: Props) {
    const hasHeader = !!(eyebrow || heading || intro);
    const className = [
        "gt-section",
        id ? "gt-landing-section" : "",
        surface ? "gt-section--surface" : "",
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <section id={id} className={className} style={style}>
            {hasHeader && (
                <header className={`gt-section__header gt-section__header--${align}`}>
                    {eyebrow && <div className="gt-eyebrow">{eyebrow}</div>}
                    {heading && <h2 className="gt-h2 gt-section__heading">{heading}</h2>}
                    {intro && <p className="gt-section__intro">{intro}</p>}
                </header>
            )}
            {children}
        </section>
    );
}
